"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePoleToolController = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const theme_1 = require("../../../components/theme");
const services_1 = require("../../../services");
const topological_editor_tool_abstract_ctrl_1 = require("../topological.editor.tool.abstract.ctrl");
const location_input_state_1 = require("../../../components/input/location.input.state");
const CSS = {
    withCreatePoleTool: 'c-PoleCreateTool__attached',
};
const Style = {
    [CSS.withCreatePoleTool]: {
        cursor: 'crosshair',
    },
};
(0, theme_1.addStyles)(Style);
class CreatePoleToolController extends topological_editor_tool_abstract_ctrl_1.TopologicalEditorToolController {
    constructor(ctrl) {
        super(ctrl);
        this.ctrl = ctrl;
        ctrl.classnames.push(CSS.withCreatePoleTool);
        ctrl.map.map.setOptions({ draggableCursor: 'crosshair' });
        this.bindMapClickEvent();
    }
    bindMapClickEvent() {
        this.clickEventListener = this.ctrl.map.map.addListener('click', (event) => {
            if (!this.ctrl.isCreatePoleMode) {
                return;
            }
            const { lat, lng } = event.latLng;
            const latitude = lat().toFixed(7);
            const longitude = lng().toFixed(7);
            this.createNewPole(latitude, longitude);
        });
    }
    createNewPole(latitude, longitude) {
        // Sort by updatedAt to find most recent, fallback to createdAt
        const sortedCollections = [...this.ctrl.collectionModels].sort((a, b) => {
            const aTime = a.updatedAt ? new Date(a.updatedAt).getTime() : a.createdAt ? new Date(a.createdAt).getTime() : 0;
            const bTime = b.updatedAt ? new Date(b.updatedAt).getTime() : b.createdAt ? new Date(b.createdAt).getTime() : 0;
            return bTime - aTime; // Most recent first
        });
        const mostRecentCollection = sortedCollections[0];
        if (!mostRecentCollection) {
            return;
        }
        const form = mostRecentCollection.schema;
        const rest = services_1.Services.Department.rest;
        const newCollection = core_shared_1.IkeModel.Collection.create(form, rest);
        newCollection.state.jobId = this.ctrl.tag.objectId;
        this.ctrl.createEditControllerForCollection(newCollection);
        const editCtrl = this.ctrl.getEditCtrlByRevision(newCollection.revision);
        if (!editCtrl) {
            return;
        }
        let inputState = editCtrl.changeState.getState(newCollection.editableLocationField.id);
        if (!inputState) {
            inputState = new location_input_state_1.LocationInputState(newCollection.editableLocationField.schema.displayName);
            inputState.onValue(() => {
                newCollection.editableLocationField.Mutator.edited(inputState.value);
            });
            editCtrl.changeState.addState(newCollection.editableLocationField.id, inputState);
            inputState.setValue(newCollection.editableLocationField.value);
        }
        inputState.latitude.setInputValue(latitude.toString());
        inputState.longitude.setInputValue(longitude.toString());
        this.ctrl.newPoleModel.push(newCollection);
        this.ctrl.setSelectedCollectionRevision(newCollection.revision);
        this.ctrl.refreshOverlay();
    }
    destroy() {
        this.topologicalEditorController.classnames = this.topologicalEditorController.classnames.filter((x) => x !== CSS.withCreatePoleTool);
        this.topologicalEditorController.map.map.setOptions({
            draggableCursor: '',
        });
        google.maps.event.removeListener(this.clickEventListener);
    }
}
exports.CreatePoleToolController = CreatePoleToolController;
//# sourceMappingURL=create.pole.js.map